import styled from 'styled-components';

interface IPropsStyle {
  foreword?: any;
}

export const Title = styled.h3<IPropsStyle>`
  letter-spacing: 2px;
  font-weight: 700;
  position: relative;
  font-size: 24px;
  color: #4174b4;
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 0;
  margin-top: 10px;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;

  @media (max-width: 767px) {
    font-size: 18px;
    letter-spacing: 1px;
  }

  &:before {
    content: 'Titulo';
    content: '${(props: any) => props.foreword}';
    display: block;
    color: black;
    width: 100%;
    height: auto;
    opacity: 0.1;
    font-weight: 900;
    font-size: 30px;
    letter-spacing: 2px;
    text-transform: uppercase;
    position: absolute;
    left: 2px;
    font-family: 'Montserrat', sans-serif;
    bottom: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 4px);

    @media (max-width: 767px) {
      font-size: 22px;
    }
  }
`;

export const Subtitle = styled.p`
  color: #555;
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 400;
  letter-spacing: 1px;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: 767px) {
    font-size: 13px;
    letter-spacing: 0.5px;
  }
`;
